import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IEmptyResult } from '~src/httpClient/serverApi/types/IResponse';
import { ISetScheduleParams } from '~src/spacesPlatform/utils/actionParams';

export class UpdateLinkedTasksScheduleRequest extends Request<ISetScheduleParams, IEmptyResult> {
  constructor(params: ISetScheduleParams) {
    super('updateLinkedTasksSchedule', params);
  }
}
